window.fundSearchAutoComplete = function () {
    document.querySelectorAll('.fund-search-block').forEach(function (container) {
        const form = container.querySelector('[data-blockid]');
        if (!form) return;

        const input = container.querySelector('.fund-search-input');
        const resultTable = container.querySelector('.fund-search-result-table');
        const tbody = resultTable && resultTable.querySelector('tbody');

        const blockId = form.getAttribute('data-blockid') ?? 0;
        const language = form.getAttribute('data-language') ?? '';
        if (blockId == 0) return;

        var dataList = [];

        const dataIsland = container.querySelector('.fund-search-data');
        if (dataIsland) {
            dataList = JSON.parse(dataIsland.textContent);
        } else {
            fetch(`/Main/FundSearchPanelBlock/GetSearchPanelData?blockId=${blockId}&language=${language}`)
                .then(response => response.json())
                .then(data => {
                    if (data.Success) {
                        console.log('Request succeeded:', data.Rows);
                        dataList = data.Rows;
                    } else {
                        console.error('Request failed with error:', data.Error);
                    }
                })
                .catch(error => {
                    console.error('Fetch request failed:', error);
                });
        }

        const drawTable = (arrayItems) => {
            var tableMarkup = '';
            arrayItems.forEach((item) => {
                var url = item.Url;
                var tableRow = '<tr>';
                item.Values.forEach((subItem, subIndex) => {
                    if (!subItem) subItem = '';
                    if (subIndex === 0) {
                        tableRow += "<td><a href='" + url + "' class=''>" + subItem + '</a></td>';
                    } else {
                        tableRow += '<td>' + subItem + '</td>';
                    }
                });
                tableRow += '</tr>';
                tableMarkup += tableRow;
            });
            return tableMarkup;
        };

        container.querySelector('.fund-search-result-table table tbody').addEventListener('click', (e) => {
            const row = e.target.closest('tr');
            if (!row) return;

            const link = row.querySelector('td a');
            if (!link) return;

            link.click();
        });

        input.addEventListener('keyup', function () {
            if (this.value.trim().length == 0) {
                resultTable.style.display = 'none';
                return;
            }
            tbody.innerHTML = '';
            const escaped = this.value.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const regex = new RegExp('\\b' + escaped);
            const filteredArray = dataList.filter(item =>
                item.Values.some(v => v && regex.test(v.toLowerCase())) ||
                item.Keywords.some(k => regex.test(k.toLowerCase()))
            );

            tbody.innerHTML = drawTable(filteredArray);
            resultTable.style.display = filteredArray.length > 0 ? '' : 'none';
        });

        function swapPlaceholder() {
            const placeholderText = input.getAttribute('data-placeholdertext');
            const mobilePlaceholderText = input.getAttribute('data-mobileplaceholdertext');
            if (!placeholderText || !mobilePlaceholderText) return;
            input.setAttribute('placeholder', window.innerWidth >= 768 ? placeholderText : mobilePlaceholderText);
        }

        window.addEventListener('load', swapPlaceholder);
        window.addEventListener('resize', swapPlaceholder);
    });
};

window.addEventListener('DOMContentLoaded', fundSearchAutoComplete);
